export enum ViewType {
  CUSTOMER = "customer",
  RESTAURANT = "restaurant",
}
